export default __webpack_public_path__ + "static/media/Acubis-2.5fr.705dd3a2.jpg";